// ════════════════════════════════════════════════════════════════════════
//  Handing the card PDF to the browser's download folder.
//
//  Built in the browser: for a printout there is no reason to send practice
//  codes through a server. Extracted from the page because it is the only part
//  of it that touches the DOM directly.
// ════════════════════════════════════════════════════════════════════════

import { useCallback, useState } from "react";
import { cardsFileName, createCardsPdf } from "../lib/cards.js";

export function useCardsDownload() {
  const [printing, setPrinting] = useState(false);

  const download = useCallback(
    async (input: {
      className: string;
      schoolYear: string;
      codes: readonly string[];
    }) => {
      setPrinting(true);
      try {
        const bytes = await createCardsPdf({
          schoolClass: input.className,
          schoolYear: input.schoolYear,
          codes: input.codes,
          // Ohne konfigurierte Adresse bleibt das Kärtchen ohne QR-Code.
          appUrl: (import.meta.env as Record<string, string>).VITE_LERN_APP_URL,
        });
        const url = URL.createObjectURL(
          new Blob([bytes as BlobPart], { type: "application/pdf" }),
        );
        const link = document.createElement("a");
        link.href = url;
        link.download = cardsFileName(input.className, input.schoolYear);
        link.click();
        URL.revokeObjectURL(url);
      } finally {
        setPrinting(false);
      }
    },
    [],
  );

  return { printing, download };
}
